<template>
  <div class="policies">
    <el-card class="pc-head" shadow="never">
      <div slot="header" class="clearfix">
        <span class="pc-title">用户协议页面管理</span>
        <span class="pc-sub">共 {{ policies.length }} 个页面 · 点击「打开」在新标签访问线上页面</span>
      </div>
      <el-alert
        type="info"
        :closable="false"
        title="说明"
        description="本页集中登记站点已有的用户协议 / 隐私政策类页面，方便统一管理。新增页面时，在 src/admin/views/Policies.vue 顶部的 POLICIES 数组里追加一条即可。"
      />
    </el-card>

    <el-card shadow="never">
      <el-table :data="policies" border stripe style="width: 100%">
        <el-table-column prop="product" label="产品" width="120" />
        <el-table-column prop="title" label="页面标题" min-width="160" />
        <el-table-column label="类型" width="110">
          <template slot-scope="scope">
            <el-tag :type="typeTag(scope.row.type)" size="small">{{ scope.row.type }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="平台" width="110">
          <template slot-scope="scope">
            <el-tag :type="platformTag(scope.row.platform)" size="small" plain>{{ scope.row.platform }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="路由路径" min-width="200">
          <template slot-scope="scope">
            <code class="pc-path">{{ scope.row.path }}</code>
          </template>
        </el-table-column>
        <el-table-column prop="effective" label="生效日期" width="140" />
        <el-table-column label="源文件" min-width="280">
          <template slot-scope="scope">
            <code class="pc-file">{{ scope.row.file }}</code>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="openPage(scope.row)">打开</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
// 站点已有的用户协议 / 隐私政策类页面登记清单。
// 新增页面时，往这个数组追加一条即可（path 为前端路由，file 为源码位置）。
// 同一条协议若区分 iOS / 鸿蒙，拆成两行登记（path 带 ?platform=ios 为苹果版，不带为华为/鸿蒙版）。
const POLICIES = [
  {
    product: '元收纳',
    title: '会员服务协议',
    type: '会员协议',
    platform: '华为/鸿蒙',
    path: '/member-agreement',
    effective: '2026-08-01',
    file: 'src/views/agreements/yuanshou-na/member-service.vue',
  },
  {
    product: '元收纳',
    title: '会员服务协议',
    type: '会员协议',
    platform: 'iOS',
    path: '/member-agreement?platform=ios',
    effective: '2026-08-01',
    file: 'src/views/agreements/yuanshou-na/member-service.vue',
  },
  {
    product: '元收纳',
    title: '用户隐私政策',
    type: '隐私政策',
    platform: '华为/鸿蒙',
    path: '/privacy-policy',
    effective: '2026-08-01',
    file: 'src/views/agreements/yuanshou-na/privacy-policy.vue',
  },
  {
    product: '元收纳',
    title: '用户隐私政策',
    type: '隐私政策',
    platform: 'iOS',
    path: '/privacy-policy?platform=ios',
    effective: '2026-08-01',
    file: 'src/views/agreements/yuanshou-na/privacy-policy.vue',
  },
  {
    product: '笔记相册',
    title: '用户协议',
    type: '用户协议',
    platform: 'iOS',
    path: '/qimiao-xiangce/user-agreement',
    effective: '2026-08-25',
    file: 'src/views/agreements/qimiao-xiangce/user-agreement.vue',
  },
  {
    product: '影传',
    title: '用户协议',
    type: '用户协议',
    platform: '华为/鸿蒙',
    path: '/yingchuan/user-agreement',
    effective: '2026-08-29',
    file: 'src/views/agreements/yingchuan/user-agreement.vue',
  },
  {
    product: '影传',
    title: '用户协议',
    type: '用户协议',
    platform: 'iOS',
    path: '/yingchuan/user-agreement?platform=ios',
    effective: '2026-08-29',
    file: 'src/views/agreements/yingchuan/user-agreement.vue',
  },
  {
    product: '官网',
    title: '用户协议',
    type: '用户协议',
    platform: '通用',
    path: '/userprotocol',
    effective: '动态内容',
    file: 'src/views/userprotocol.vue',
  },
  {
    product: '官网',
    title: '隐私政策',
    type: '隐私政策',
    platform: '通用',
    path: '/privacy',
    effective: '动态内容',
    file: 'src/views/privacy.vue',
  },
]

export default {
  name: 'AdminPolicies',
  data() {
    return {
      policies: POLICIES,
    }
  },
  methods: {
    typeTag(type) {
      if (type === '会员协议') return 'warning'
      if (type === '用户协议') return 'success'
      return 'info' // 隐私政策
    },
    platformTag(platform) {
      if (platform === 'iOS') return 'primary'
      if (platform === '华为/鸿蒙') return ''
      return 'info' // 通用
    },
    openPage(row) {
      const url = window.location.origin + row.path
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
.policies {
  text-align: left;
}
.pc-head {
  margin-bottom: 16px;
}
.pc-title {
  font-size: 16px;
  font-weight: 600;
}
.pc-sub {
  margin-left: 12px;
  color: #888;
  font-size: 13px;
}
.pc-path,
.pc-file {
  font-family: Menlo, Consolas, monospace;
  font-size: 12px;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  color: #333;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/admin/views/Policies.vue